import myMM from '../../date-picker/locale/my_MM';
export default myMM;
